import axios from 'axios';

import settings from '../libs/config';
import ApiError from './apiError.js';

const endpoint = settings.api_host + "/distributionlist/get";
const endpointUpdateDistributionList = settings.api_host + "/distributionlist/update";

export const getDistributionList = async (distributionlist) => {
	if (!distributionlist) {
		throw new Error("Missing Distribution List ID");
	}

	try {
		const response = await axios.get(endpoint, {
			params: {
				distributionlist
			}
		});

		const data = response.data;
		return data.result;
	} 
	catch (error) {
		throw new ApiError(error);
	}
};

export const updateDistributionList = async(dist_id, verifiedEmails) => {
	if (!dist_id) {
		throw new Error("Missing Distribution List ID");
	}
	if (!verifiedEmails) {
		throw new Error("Missing Distribution List Emails");
	}

	try {
		const response = await axios.get(endpointUpdateDistributionList, {
			params: {
				dist_id: dist_id,
				verifiedEmails: verifiedEmails
			}
		});
		const data = response.data;
		return data.result;

	} 
	catch (error) {
		throw new ApiError(error);
	}
};


// WEBPACK FOOTER //
// ./src/api/distributionList.js